
<template>
    <van-dialog
        v-model="showDialog"
        :closeOnClickOverlay="true"
        :show-cancel-button="false"
        :show-confirm-button="false"
        class="verifyCodeDialog"
        :get-container="mountEle"
        >
        <div class="title">图形验证码</div>
        <div class="sendTips">
            <div class="inputBox">
                <input v-model="code" class="codeInput" placeholder="请输入图形验证码" @blur="resetScroll" />

                <div class="codeImg">
                    <img :src="loginState.beasImg"  @click.stop="refreshImgFn()"/>
                </div>
            </div>
        </div>
        <div class="btnBox">
            <button class="confirm" @click="onBtn()">确认</button>
        </div>
    </van-dialog>
</template>

<script>
import {
    mapState,
    mapActions
} from 'vuex'

export default {
    name: 'verifyCodeDialog',
    props: {
        imgCode: {
            type: String,
            default: ''
        },
        mountEle: {
            type: String,
            default: ''
        }
    },
    components: {
    },
    data () {
        return {
            code: '', // 验证码
            showDialog: false
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    computed: {
        ...mapState({
            loginState: ({
                login
            }) => login
        })
    },
    watch:{
        imgCode (n) {
            this.code = n
        },
    },
    methods: {
        ...mapActions([
            'getGraphValidateCode',
            'getSmsCode',
        ]),
        /**
         * 修复iphone Xr 输入法关闭页面没有还原位置导致弹窗点击不了确定事情
        */
        resetScroll () {
            document.body.scrollTop = 0
        },
        /**
         * 显示弹窗
         */
        show () {
            this.showDialog = true
            this.getGraphValidateCode()
        },
        /**
         * 隐藏弹窗
         */
        hide () {
            this.showDialog = false
        },
        /**
         * 刷新验证码
         */
        refreshImgFn () {
            this.getGraphValidateCode()
        },
        /**
         * 弹窗关闭前判断是否要关闭
         */
        onBtn (action) {
            if (this.code === '') {
                this.$toast('验证码不能为空')
                return
            }
            this.$emit('callback', this.code)
        },
        /**
         * 重置
         */
        onReset () {
            this.code = ''
        },
    }
}
</script>

<style lang="stylus" scoped>
.verifyCodeDialog
    .title
        padding 30px 0
        border-bottom 1px solid #eee
        text-align center
    .btnBox
        font-size 0
        display flex
        border-top 1px solid #eee
        button
            flex 1
            display block
            text-align center
            font-size 42px
            height 100px
            line-height 50px
            border none
            background none
        button.cancel
            color #999
            border-right 1px solid #eee
        button.confirm
            color #fd2d2d
    .sendTips
        padding 60px 40px
        position relative
        .inputBox
            display flex
            height 60px
            line-height 60px
            margin-bottom 20px
            .text
                color #666
                font-size 28px
                display block
                width 130px
            input
                flex 1
                width 100px
                height 100%
                color #033333
                display block
                background #eeeeee
                padding 0 16px
                font-size 28px
            .codeImg
                margin-left 20px
                height 60px
                width 180px
                img
                    width 100%
                    height 100%
</style>
<style lang="stylus">
body
    .verifyCodeDialog
        border-radius 40px !important
        .van-dialog__confirm
            color #fd2d2d
</style>
